import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';
import { getClusterFeatureClassName } from '../../../../utils/getClusterFeatureClassName';

interface IOfferListProps {
  offersLength: number;
  offers: React.ReactNode[];
}

export function OfferList({ offersLength, offers }: IOfferListProps) {
  return (
    <div className={classNames(styles['container'], styles[getClusterFeatureClassName(offersLength)])}>
      <div className={classNames(styles['list'], offersLength % 2 !== 0 && styles['list--odd'])}>{offers}</div>
    </div>
  );
}
